export default __webpack_public_path__ + "static/media/py.186a27c4.png";